// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrFieldDto
 */
export interface IOcrFieldDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrFieldDto
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrFieldDto
     */
    confidence?: string;
}

/**
 * Check if a given object implements the IOcrFieldDto interface.
 */
export function instanceOfIOcrFieldDto(value: object): value is IOcrFieldDto {
    return true;
}

export function IOcrFieldDtoFromJSON(json: any): IOcrFieldDto {
    return IOcrFieldDtoFromJSONTyped(json, false);
}

export function IOcrFieldDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrFieldDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
    };
}

export function IOcrFieldDtoToJSON(json: any): IOcrFieldDto {
    return IOcrFieldDtoToJSONTyped(json, false);
}

export function IOcrFieldDtoToJSONTyped(value?: IOcrFieldDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'confidence': value['confidence'],
    };
}

